"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import NavigationSection from "src/components/Common/NavigationSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import { flutterStatsData, flutterTechnologiesData } from "src/utils/mock/webAppData";
import {
  GeofencingHeroData,
  geofencingAboutData,
  geofencingDevelopSolutionsAndProcessData,
  geofencingFaqData,
  geofencingServices,
  geofencingPortfolioData,
} from "src/utils/mock/geofencingMarketingData";

export default function GeofencingMarketing({ caseStudies: apiCaseStudies }) {
  const liveProjects = apiCaseStudies?.projects?.liveProjects || [];

  const activeProjects = liveProjects.filter((project) => {
    return project.projectStatus?.toLowerCase() === "active";
  });

  const filteredData = caseStudies
    ? {
        ...geofencingPortfolioData,
        projects: {
          liveProjects: activeProjects,
        },
      }
    : geofencingPortfolioData;
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;

  return (
    <div>
      <AppHero heroData={GeofencingHeroData} />
      <TechStats stats={flutterStatsData} />
      <NavigationSection data={geofencingServices} leftHeading="Geofencing" rightHeading=" Marketing Solutions" />
      <WhyChooseUs data={geofencingDevelopSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-text-primary px-6! md:px-12! relative overflow-hidden font-sans ">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-500/5 dark:bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-500/5 dark:bg-blue-950/10 blur-[150px] -z-10 rounded-full" />
        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={flutterTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Geofencing Marketing" sections={geofencingAboutData} />
        </div>
      </section>
      <FAQSection faqs={geofencingFaqData} />
      <CommonContactSection />
    </div>
  );
}
